import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import diagnosticCartReducer from './reducers/diagnosticCartReducer';
import userAuthReducer from './reducers/userAuthReducer';
import { Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux';

const reducers = combineReducers({
    diagnosticCart: diagnosticCartReducer,
    userAuth: userAuthReducer,
})

const store = createStore(reducers);

ReactDOM.render(<Provider store={store}><BrowserRouter><App /></BrowserRouter></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
